import Component from '@glimmer/component';
import type FamilyModel from 'frontend/models/family';
import getParentFamilies from 'frontend/utils/get-parent-families';

interface SearchPageFiltersFamiliesListComponentArgs {
  families: FamilyModel[];
}

export default class SearchPageFiltersFamiliesListComponent extends Component<SearchPageFiltersFamiliesListComponentArgs> {
  constructor(
    owner: unknown,
    args: SearchPageFiltersFamiliesListComponentArgs
  ) {
    super(owner, args);
  }
  get familiesWithoutParents() {
    return getParentFamilies(this.args.families);
  }
}
